import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import CoachCardSm from 'components/coach-card-small'
import { useStyles, Header, HelperText, NextButton } from '../styles'
import { useWizardFormContext } from 'components/wizard-form/context'
import { Questionnaire } from '../constants'

const SelectPlan = ({ coach }) => {
  const classes = useStyles()
  const { advance } = useWizardFormContext()
  const { register, control } = useFormContext()

  const currentStep = 7
  const answers = [
    'As soon as possible',
    'In the next 30 days',
    'Unsure,  looking for more information',
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item md={8} xs={12}>
          <Header variant="h4">Coaching Request</Header>
          <HelperText variant="body1">
            These questions will help the coach to find out more about you and
            the way you golf.
          </HelperText>
        </Grid>
        <Grid item md={4} xs={12} style={{ marginLeft: 'auto' }}>
          <CoachCardSm coach={coach} />
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item md={8} xs={12}>
          <Typography variant="h6" className={classes.sectionTitle}>
            {Questionnaire.TIME_TO_IMPROVE.question}
          </Typography>
          <RadioGroup>
            <Controller
              control={control}
              name={`questionnaire[${currentStep}].answer`}
              defaultValue=""
              render={({ onChange, value }) => (
                <Grid container spacing={3}>
                  {answers.map(answer => (
                    <Grid item md={3} xs={6} key={answer}>
                      <FormControlLabel
                        classes={{
                          root: classes.customControlLabel,
                          label: classes.formControlLabel,
                        }}
                        value={answer}
                        control={
                          <Radio
                            classes={{
                              root: classes.root,
                              checked: classes.checked,
                            }}
                            value={value}
                            name={`questionnaire[${currentStep}].answer`}
                            checked={value === answer}
                            onChange={() => {
                              onChange({ answer }.answer)
                            }}
                          />
                        }
                        label={answer}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            />
          </RadioGroup>
          <input
            type="hidden"
            ref={register()}
            name={`questionnaire[${currentStep}].question`}
            value="How soon are you looking to improve?"
          />
          <NextButton variant="contained" color="primary" onClick={advance}>
            Next
          </NextButton>
        </Grid>
      </Grid>
    </>
  )
}

export default SelectPlan
